"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GiveawayStatus = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _giftAway = require("@/api/gift-away");
var _product = require("@/api/product");
var _staff = require("@/api/staff");
var _vuePropertyDecorator = require("vue-property-decorator");
var _AddProductOrderModal = _interopRequireDefault(require("./AddProductOrderModal.vue"));
var _FilterOrder = require("./FilterOrder.vue");
var _giveaway = require("@/types/giveaway");
var _warehouse = require("@/api/warehouse");
var ProductOrderForm = /*#__PURE__*/function (_Vue) {
  function ProductOrderForm() {
    var _this;
    (0, _classCallCheck2.default)(this, ProductOrderForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ProductOrderForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", void 0);
    (0, _defineProperty2.default)(_this, "statusForm", void 0);
    (0, _defineProperty2.default)(_this, "giveawayStatus", void 0);
    (0, _defineProperty2.default)(_this, "isLinkShopee", void 0);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "productId", null);
    (0, _defineProperty2.default)(_this, "staffs", []);
    (0, _defineProperty2.default)(_this, "products", []);
    (0, _defineProperty2.default)(_this, "rules", {
      staffId: {
        required: true,
        message: "Field is required!",
        trigger: "submit"
      }
    });
    (0, _defineProperty2.default)(_this, "OrderStatus", _FilterOrder.OrderStatus);
    (0, _defineProperty2.default)(_this, "summary", {
      quantity: 0
    });
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "GiveawayStatus", GiveawayStatus);
    (0, _defineProperty2.default)(_this, "GiveawayType", _giveaway.GiveawayType);
    return _this;
  }
  (0, _inherits2.default)(ProductOrderForm, _Vue);
  return (0, _createClass2.default)(ProductOrderForm, [{
    key: "created",
    value: function created() {
      // this.fetchProduct();
      this.fetchStaffs();
    }
    // xu ly chon lotNumber đối với đơn link shopee
  }, {
    key: "handleSelectLotNumber",
    value: function handleSelectLotNumber(val, item) {
      var lot = item.lotnumbers[val];
      this.handleChangeProduct((0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), lot));
    }
    // lấy ds lotNumber của sản phẩm mỗi khi nhấn select
  }, {
    key: "fetchOrderLotNumber",
    value: function () {
      var _fetchOrderLotNumber = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(item) {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _warehouse.warehouseApi.findGroup(item.id);
            case 2:
              res = _context.sent;
              this.$set(item, "lotnumbers", res.data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchOrderLotNumber(_x) {
        return _fetchOrderLotNumber.apply(this, arguments);
      }
      return fetchOrderLotNumber;
    }()
  }, {
    key: "fetchStaffs",
    value: function fetchStaffs() {
      var _this2 = this;
      _staff.staffApi.findAll().then(function (res) {
        return _this2.staffs = res.data.data;
      });
    }
  }, {
    key: "handleAddProduct",
    value: function handleAddProduct() {
      this.$refs.productModal.handleCreate();
    }
  }, {
    key: "watchFormProducts",
    value: function watchFormProducts(data) {
      if (!data) {
        return;
      }
      this.summary.quantity = data.reduce(function (prev, cur) {
        return prev + +cur.quantity;
      }, 0);
    }
  }, {
    key: "transformData",
    get: function get() {
      var data = [];
      this.form.products.forEach(function (e) {
        data.push(e);
      });
      return data;
    }
  }, {
    key: "handleChangeProduct",
    value: function handleChangeProduct(data) {
      if (data.indexProduct != undefined) {
        var product = this.form.products[data.indexProduct];
        product = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, product), data.product), {}, {
          product: data.product,
          vatPrice: 0,
          commissionAmount: 0,
          quantity: 1,
          totalPrice: 0,
          lotNumber: data.lotNumber,
          expired: data.expired,
          productQuantity: data.quantity,
          dateOfManufacture: data.dateOfManufacture
        });
        return this.form.products.splice(data.indexProduct, 1, product);
      }
      // if (this.form.products.some((e) => e.id == data.product.id)) {
      //   return this.$message.error("This product is exist!");
      // }
      if (data.product) {
        this.form.products.push((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data.product), {}, {
          product: data.product,
          vatPrice: 0,
          commissionAmount: 0,
          quantity: 1,
          totalPrice: 0,
          realPrice: data.product.retailPrice,
          lotNumber: data.lotNumber,
          expired: data.expired,
          productQuantity: data.quantity,
          dateOfManufacture: data.dateOfManufacture,
          indexProduct: this.form.products.length
        }));
      }
    }
  }, {
    key: "handleRemoveProd",
    value: function () {
      var _handleRemoveProd = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(index, item) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.statusForm == "update" && item.detailId)) {
                _context2.next = 9;
                break;
              }
              _context2.next = 3;
              return this.$confirm("Confirm delete product", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 3:
              this.form.products.splice(index, 1);
              _context2.next = 6;
              return _giftAway.giveAwayApi.deleteDetail(item.detailId);
            case 6:
              this.$notify({
                title: "Delete product",
                message: "Successfully",
                type: "success"
              });
              _context2.next = 10;
              break;
            case 9:
              this.form.products.splice(index, 1);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleRemoveProd(_x2, _x3) {
        return _handleRemoveProd.apply(this, arguments);
      }
      return handleRemoveProd;
    }()
  }, {
    key: "handleEditProd",
    value: function () {
      var _handleEditProd = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(index, item) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.$refs.productModal.handleUpdate(index, item);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleEditProd(_x4, _x5) {
        return _handleEditProd.apply(this, arguments);
      }
      return handleEditProd;
    }()
  }, {
    key: "fetchProduct",
    value: function fetchProduct(search) {
      var _this3 = this;
      this.loading = true;
      _product.productApi.findAll({
        limit: 50,
        page: 1,
        search: search
      }).then(function (res) {
        return _this3.products = res.data.products;
      }).finally(function () {
        return _this3.loading = false;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  required: true
})], ProductOrderForm.prototype, "form", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "statusForm", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "giveawayStatus", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "isLinkShopee", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.products", {
  deep: true
})], ProductOrderForm.prototype, "watchFormProducts", null);
ProductOrderForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    AddProductOrderModal: _AddProductOrderModal.default
  }
})], ProductOrderForm);
var _default = exports.default = ProductOrderForm;
var GiveawayStatus;
(function (GiveawayStatus) {
  GiveawayStatus["Pending"] = "PENDING";
  GiveawayStatus["Complete"] = "COMPLETE";
})(GiveawayStatus || (exports.GiveawayStatus = GiveawayStatus = {}));